import {
    GetUserSelectableTimeZonesRequest,
    IGetUserSelectableTimeZonesResult,
} from '../../ts/ServerApi/requests/GetUserSelectableTimeZonesRequest';
import { ITimeZone } from '../../ts/ServerApi/types/ITimeZone';
import WebHttpClient from '../../httpClient/WebHttpClient';

export interface IGetTimeZonesResult {
    extraTimeZonesList: ITimeZone[];
    curatedTimeZonesList: ITimeZone[];
    serverTimeZone: ITimeZone;
    fullTimeZonesList: ITimeZone[];
}

function getAll(): Promise<IGetTimeZonesResult> {
    return WebHttpClient.sendRequest(new GetUserSelectableTimeZonesRequest())
        .then((result: IGetUserSelectableTimeZonesResult) => {
            return {
                extraTimeZonesList: result.extraTimeZonesList,
                curatedTimeZonesList: result.curatedTimeZonesList,
                serverTimeZone: result.serverTimeZone,
                fullTimeZonesList: result.curatedTimeZonesList.concat(result.extraTimeZonesList).sort((tz1, tz2)=> {
                    if (tz1.timeZoneRawOffsetMinutes>tz2.timeZoneRawOffsetMinutes) {
                        return 1;
                    }
                    if (tz1.timeZoneRawOffsetMinutes<tz2.timeZoneRawOffsetMinutes) {
                        return -1;
                    }
                    return 0;
                })
            };
    });
}

export const TimeZones = {getAll};
